<script setup lang="ts">
import { computed, resolveComponent } from 'vue'
import type { CmsBlockImageTwoColumn } from '@shopware/composables'

const props = defineProps<{
    content: CmsBlockImageTwoColumn
}>()

const { getCmsSlot, getCmsElementName } = useCms()
const leftSlot = computed(() => getCmsSlot(props.content, 'left'))
const rightSlot = computed(() => getCmsSlot(props.content, 'right'))

const imageProps = (slot: ReturnType<typeof getCmsSlot>) => {
    if (slot?.type === 'image') {
        return { imageWidth: 789, imageHeight: 798, imageSizes: '304px sm:367px md:487px lg:615px xl:743px 2xl:789px' }
    }
    return {}
}
</script>

<template>
    <div class="grid grid-cols-2 gap-4 md:gap-8">
        <component
            :is="resolveComponent(getCmsElementName(leftSlot?.type))"
            v-if="leftSlot"
            :content="leftSlot"
            v-bind="imageProps(leftSlot)"
        />
        <component
            :is="resolveComponent(getCmsElementName(rightSlot?.type))"
            v-if="rightSlot"
            :content="rightSlot"
            v-bind="imageProps(rightSlot)"
        />
    </div>
</template>